import { render, staticRenderFns } from "./WordListSlider.vue?vue&type=template&id=0ca589c6&scoped=true"
import script from "./WordListSlider.vue?vue&type=script&lang=js"
export * from "./WordListSlider.vue?vue&type=script&lang=js"
import style0 from "./WordListSlider.vue?vue&type=style&index=0&id=0ca589c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca589c6",
  null
  
)

export default component.exports